<template>
    <div>
        <div class="box box-primary">
            <div class="box-header with-border">
                <h3 class="box-title">Filter</h3>
                <div class="box-tools pull-right">
                    <button
                        class="btn btn-box-tool"
                        title="Collapse"
                        type="button"
                        @click="toggleCollapse('filter')"
                    >
                        <i
                            :class="[getCollapseStatus('filter') ? 'fa-minus' : 'fa-plus']"
                            class="fa"
                        ></i>
                    </button>
                </div>
            </div>
            <vue-slide-up-down
                :active="getCollapseStatus('filter')"
                :duration="durationCollapse"
            >
                <div class="box-body">
                    <div class="box-body-tab">
                        <DateRangeComponent
                            :id="getDynamicId('date')"
                            ref="dateRef"
                            :disabled="sending"
                            :start="start"
                            :end="end"
                            :max-span="maxSpan"
                            class-input="form-control"
                            class-main-block="form-group col-lg-4 col-md-6 col-xs-12"
                            placeholder="Dates Range"
                            title="Dates"
                            @change="changeDate"
                        />
                        <select-component
                            id="groupBy"
                            ref="groupByRef"
                            :searchable="true"
                            :disabled="sending"
                            :items="itemsGroupBy"
                            :selected="getExternalParam('groupBy')"
                            placeholder="Select group by"
                            class-main-block="form-group col-lg-4 col-md-6 col-xs-12"
                            title="Group by"
                            @change="changeGroupBy"
                        />
                        <checkbox-component
                            id="clearCache"
                            ref="clearCacheRef"
                            :selected="getExternalParam('clearCache')"
                            :disabled="sending"
                            class-main-block="form-group col-lg-4 col-md-6 col-xs-12"
                            title="Clear Cache"
                            @change="changeFilterDefault"
                        />
                        <multi-select-component
                            v-if="existGroupBy"
                            id="filter"
                            ref="filterRef"
                            :searchable="true"
                            :disabled="sending"
                            :items="itemsFilter"
                            :selected="getExternalParam('filter')"
                            placeholder="Select or leave empty"
                            class-main-block="form-group col-lg-4 col-md-6 col-xs-12"
                            title="Filters"
                            @change="changeFilter"
                        />
                        <template v-for="value in itemsFilterSelected">
                            <multi-select-component
                                v-if="existFilter"
                                :id="value.id"
                                :key="value.id"
                                ref="formItemsDynamicRef"
                                :class-main-block="value.classMainBlock"
                                :class-select="value.classSelect"
                                :disabled="sending || disabledDynamicFilter"
                                :items="getItems(value.id)"
                                :route="value.route"
                                :selected="getExternalParam(value.id)"
                                :title="value.name"
                                placeholder="Select or leave empty"
                                @change="callMethod(value.change)"
                                @setItems="setItems"
                            />
                        </template>
                        <checkbox-component
                            v-if="itemsFilterSelected.length > 0"
                            id="onlyActive"
                            ref="onlyActiveRef"
                            :selected="onlyActive"
                            :disabled="sending"
                            class-main-block="form-group col-lg-2 col-md-6 col-xs-12"
                            title="Only Active"
                            @change="changeOnlyActive"
                        />
                        <div class="form-group col-xs-12">
                            <label class="col-xs-12 hidden-xs hidden-lg"></label>
                            <button
                                :disabled="!existGroupBy || sending || onlyExport"
                                class="btn btn-sm btn-primary"
                                type="button"
                                @click="getReport()"
                            >
                                Apply
                            </button>
                            <button
                                :disabled="sending"
                                class="btn btn-sm btn-info"
                                type="button"
                                @click="clearFilter()"
                            >
                                Clear
                            </button>
                            <div class="delimiter-button"></div>
                            <button
                                :disabled="!existGroupBy || sending"
                                class="btn btn-sm bg-yellow"
                                type="button"
                                @click="getReport(true)"
                            >
                                Export
                            </button>
                        </div>
                    </div>
                </div>
            </vue-slide-up-down>
        </div>
        <div class="box box-primary">
            <div class="box-header with-border">
                <h3 class="box-title">Report</h3>
                <div class="box-tools pull-right">
                    <button
                        class="btn btn-box-tool"
                        title="Collapse"
                        type="button"
                        @click="toggleCollapse('report')"
                    >
                        <i
                            :class="[getCollapseStatus('report') ? 'fa-minus' : 'fa-plus']"
                            class="fa"
                        ></i>
                    </button>
                </div>
            </div>
            <vue-slide-up-down
                :active="getCollapseStatus('report')"
                :duration="durationCollapse"
            >
                <div
                    v-show="sending && showPreloader"
                    :class="{ 'box-body': sending }"
                >
                    <img
                        alt="Preloader"
                        class="table-preloader"
                        src="img/preloader.png"
                    />
                </div>
                <div
                    v-if="report === null && !showPreloader"
                    class="box-body"
                >
                    <p v-if="!showError">No results found.</p>
                    <p v-else>Error occurred on the server side</p>
                </div>
                <div
                    v-if="report !== null && !showPreloader"
                    class="box-body table-responsive no-padding"
                >
                    <dlr-report-table
                        v-if="report.totals !== null"
                        :report="report"
                        :typeReport="typeReport"
                        :additional-relation-titles="additionalRelationTitles"
                    />
                </div>
            </vue-slide-up-down>
        </div>
    </div>
</template>

<script>
import DlrReportTable from './DLRReportTableComponent';
import DateRangeComponent from '@/components/partials/DateRangeComponent';

export default {
    components: {
        DlrReportTable,
        DateRangeComponent,
    },
    props: {
        idTab: {
            type: String,
            default: '',
        },
        count: {
            type: Number,
            default: 0,
        },
        dataItems: {
            type: Array,
            default: () => [],
        },
        disabledDynamicFilter: {
            type: Boolean,
            default: false,
        },
        externalParams: {
            type: Object,
            default: () => ({}),
        },
    },
    data: function () {
        return {
            onlyActive: this.getExternalParam('onlyActive', true),
            collapse: {
                filter: true,
                report: true,
            },
            durationCollapse: 700,
            report: null,
            sending: false,
            showPreloader: false,
            showError: false,
            dateRange: null,
            start: this.getExternalParam('start'),
            end: this.getExternalParam('end'),
            maxSpan: 30,
            onlyExport: false,
            existGroupBy: false,
            existFilter: false,
            typeReport: {},
            additionalRelationTitles: {},
            itemsFilterSelected: [],
            itemsGroupBy: [
                { id: 'api', name: 'API' },
                { id: 'provider', name: 'API Provider' },
                { id: 'campaign', name: 'Campaign' },
                { id: 'carrier', name: 'Carrier' },
                { id: 'contact', name: 'Contact Number' },
                { id: 'contacts_list', name: 'Contacts List' },
                { id: 'contacts_list_tag', name: 'Contacts List Tag' },
                { id: 'contacts_list_category', name: 'Contacts List Category' },
                { id: 'gender', name: 'Gender' },
                { id: 'predefined_body', name: 'Predefined Body' },
                { id: 'predefined_body_category', name: 'Predefined Body Category' },
                { id: 'short_domain', name: 'Short Domain' },
                { id: 'offer', name: 'Offer' },
                { id: 'offer_tag', name: 'Offer Tag' },
                { id: 'tld', name: 'Short Domain TLD' },
                { id: 'ip', name: 'Short Domain IP' },
                { id: 'timezone', name: 'Timezone' },
                { id: 'source_number', name: 'Source Number' },
                { id: 'reason', name: 'Reason' },
                { id: 'label', name: 'Label' },
            ],
            formItems: [
                { id: 'date', type: 'static' },
                { id: 'groupBy', type: 'static' },
                { id: 'filter', type: 'static' },
                { id: 'onlyActive', type: 'static' },
                { id: 'clearCache', type: 'static' },
                { id: 'api', type: 'dynamic' },
                { id: 'campaign', type: 'dynamic' },
                { id: 'carrier', type: 'dynamic' },
                { id: 'contacts_list', type: 'dynamic' },
                { id: 'contacts_list_tag', type: 'dynamic' },
                { id: 'contacts_list_category', type: 'dynamic' },
                { id: 'offer', type: 'dynamic' },
                { id: 'provider', type: 'dynamic' },
                { id: 'timezone', type: 'dynamic' },
                { id: 'tld', type: 'dynamic' },
                { id: 'gender', type: 'dynamic' },
                { id: 'reason', type: 'dynamic' },
                { id: 'label', type: 'dynamic' },
                { id: 'offer_tag', type: 'dynamic' },
            ],
            itemsFilter: [
                {
                    name: 'APIs',
                    id: 'api',
                    route: '/dlr-report/get-filter-list?entity=api',
                    classMainBlock: 'form-group col-lg-4 col-md-6 col-xs-12',
                    classSelect: 'form-control',
                    change: 'changeFilterDefault',
                },
                {
                    name: 'API Providers',
                    id: 'provider',
                    route: '/dlr-report/get-filter-list?entity=provider',
                    classMainBlock: 'form-group col-lg-4 col-md-6 col-xs-12',
                    classSelect: 'form-control',
                    change: 'changeFilterDefault',
                },
                {
                    name: 'Carriers',
                    id: 'carrier',
                    route: '/dlr-report/get-filter-list?entity=carrier',
                    classMainBlock: 'form-group col-lg-4 col-md-6 col-xs-12',
                    classSelect: 'form-control',
                    change: 'changeFilterDefault',
                },
                {
                    name: 'Contacts Lists',
                    id: 'contacts_list',
                    route: '/dlr-report/get-filter-list?entity=contacts_list',
                    classMainBlock: 'form-group col-lg-4 col-md-6 col-xs-12',
                    classSelect: 'form-control',
                    change: 'changeFilterDefault',
                },
                {
                    name: 'Contacts Lists Tag',
                    id: 'contacts_list_tag',
                    route: '/dlr-report/get-filter-list?entity=contacts_list_tag',
                    classMainBlock: 'form-group col-lg-4 col-md-6 col-xs-12',
                    classSelect: 'form-control',
                    change: 'changeFilterDefault',
                },
                {
                    name: 'Contacts List Category',
                    id: 'contacts_list_category',
                    route: '/dlr-report/get-filter-list?entity=contacts_list_category',
                    classMainBlock: 'form-group col-lg-4 col-md-6 col-xs-12',
                    classSelect: 'form-control',
                    change: 'changeFilterDefault',
                },
                {
                    name: 'Gender',
                    id: 'gender',
                    route: '/dlr-report/get-filter-list?entity=gender',
                    classMainBlock: 'form-group col-lg-4 col-md-6 col-xs-12',
                    classSelect: 'form-control',
                    change: 'changeFilterDefault',
                },
                {
                    name: 'Offers',
                    id: 'offer',
                    route: '/dlr-report/get-filter-list?entity=offer',
                    classMainBlock: 'form-group col-lg-4 col-md-6 col-xs-12',
                    classSelect: 'form-control',
                    change: 'changeFilterDefault',
                },
                {
                    name: 'Offer Tags',
                    id: 'offer_tag',
                    route: '/dlr-report/get-filter-list?entity=offer_tag',
                    classMainBlock: 'form-group col-lg-4 col-md-6 col-xs-12',
                    classSelect: 'form-control',
                    change: 'changeFilterDefault',
                },
                {
                    name: 'Timezone',
                    id: 'timezone',
                    route: '/dlr-report/get-filter-list?entity=timezone',
                    classMainBlock: 'form-group col-lg-4 col-md-6 col-xs-12',
                    classSelect: 'form-control',
                    change: 'changeFilterDefault',
                },
                {
                    name: 'Reasons',
                    id: 'reason',
                    route: '/dlr-report/get-filter-list?entity=reason',
                    classMainBlock: 'form-group col-lg-4 col-md-6 col-xs-12',
                    classSelect: 'form-control',
                    change: 'changeFilterDefault',
                },
                {
                    name: 'Label',
                    id: 'label',
                    route: '/dlr-report/get-filter-list?entity=label',
                    classMainBlock: 'form-group col-lg-4 col-md-6 col-xs-12',
                    classSelect: 'form-control',
                    change: 'changeFilterDefault',
                },
            ],
        };
    },
    mounted() {
        this.count > 1 && this.changeFilterParameter();
        this.externalParams && this.externalParams['filter'] ? (this.sending = true) : this.checkDynamicFilters();
    },
    methods: {
        getExternalParam(key, defaultParam) {
            return this.externalParams && this.externalParams[key] !== undefined
                ? this.externalParams[key]
                : defaultParam
                ? defaultParam
                : null;
        },
        callMethod(key) {
            this[key]();
        },
        getReport(csv = false) {
            let self = this;
            let mainFilter = '';
            let unnecessarySendKeys = ['filter', 'onlyActive'];

            self.formItems.forEach(function (value) {
                if (unnecessarySendKeys.some((el) => el === value.id)) {
                    return;
                }
                let currentRef = self.getCurrentRef(value.id);
                if (currentRef) {
                    let valueRef = currentRef.getValue();
                    valueRef = self.changeEmptyObject(valueRef);
                    if (valueRef) {
                        mainFilter += mainFilter.length === 0 ? '?' : '&';
                        mainFilter += self.addGetParam(value.id, valueRef);
                    }
                }
            });

            csv ? self.eventExportReport(mainFilter) : self.eventGetReport(mainFilter);
        },
        changeEmptyObject(value) {
            return typeof value === 'object' && value !== null && Object.keys(value).length === 0 ? null : value;
        },

        eventExportReport(mainFilter) {
            let link = document.createElement('a');
            document.body.appendChild(link);
            link.href = '/dlr-report/export' + mainFilter;
            link.click();
            link.remove();
        },

        eventGetReport(mainFilter) {
            let self = this;

            self.showPreloader = true;
            self.showError = false;
            self.$emit('sendForm', true);

            // Get data by filter
            axios
                .get('/dlr-report/get' + mainFilter)
                .then((response) => {
                    self.typeReport = self.itemsGroupBy.find((value) => value.id === self.$refs.groupByRef.getValue());
                    self.report = response.data.result;
                    if (self.report.items !== null) {
                        self.report.items = Object.values(self.report.items);
                    }
                    self.report =
                        self.report.items === null && self.report.totals === null && self.report.domains === null ? null : self.report;

                    if (self.report.items) {
                        // Additional relations
                        self.additionalRelationTitles = {};
                        self.report.items.forEach(function (item) {
                            if (item.additional_relations) {
                                item.additional_relations.forEach(function (relationItem) {
                                    self.additionalRelationTitles[relationItem.relation_key] = relationItem.name;
                                });
                            }
                        });
                        self.additionalRelationTitles = Object.values(self.additionalRelationTitles);

                        // Convert to number items collection
                        self.report.items.map(function (item) {
                            for (let key in item) {
                                if (Object.prototype.hasOwnProperty.call(item, key)) {
                                    key === 'entity' && item['entity'] && (item['id'] = item.entity.id);
                                }
                            }
                            return item;
                        });
                    } else {
                        this.report = null;
                    }

                    // Hide preloader
                    self.showPreloader = false;
                    self.$emit('sendForm', false);
                })
                .catch(() => {
                    this.report = null;
                    self.showPreloader = false;
                    self.showError = true;
                    this.$emit('sendForm', false);
                });
        },
        addGetParam(key, value) {
            let params = '';
            if (key === 'date') {
                let date = value.split(' - ');
                params += 'start=' + date[0] + '&end=' + date[1];
            } else if (key === 'clearCache') {
                params += key + '=' + Number(value);
            } else {
                params += key + '=' + value;
            }

            return params;
        },
        clearFilter() {
            let self = this;
            this.formItems.forEach(function (value) {
                let itemRef = self.getCurrentRef(value.id);
                if (itemRef) {
                    itemRef.clear();
                    self.externalParams && self.externalParams[value.id] && (self.externalParams[value.id] = null);
                }
            });

            this.itemsFilterSelected = [];
            self.report = null;
            self.existGroupBy = false;
            self.existFilter = false;
            self.changeFilterParameter();
        },
        changeDate(data) {
            this.checkExistGroupBy({ date: data });
            this.getCurrentRef('date').setValue(data);
            this.changeFilterParameter();
        },
        changeGroupBy(data) {
            this.reinitDataRange(data);
            this.checkExistGroupBy({ groupBy: data });
            this.changeFilterParameter();
        },
        reinitDataRange(data) {
            const dateRangeString = this.getCurrentRef('date').getValue();
            const startDate = dateRangeString.substring(0, 10);
            const endDate = dateRangeString.substring(13, 23);
            if (data === 'contact') {
                this.onlyExport = true;
                this.maxSpan = 0;
                this.start = startDate;
                this.end = startDate;
            } else {
                this.onlyExport = false;
                this.maxSpan = 30;
                this.start = startDate;
                this.end = endDate;
            }

            this.$nextTick(() => {
                this.getCurrentRef('date').init();
            });
        },
        checkExistGroupBy(data) {
            let datesExist = false;
            let groupExist = false;
            if (data.date) {
                datesExist = data.date && data.date.length > 0;
                let groupByRef = this.getCurrentRef('groupBy');
                groupExist = groupByRef.getValue() && groupByRef.getValue().length > 0;
            } else if (data.groupBy) {
                groupExist = data.groupBy && data.groupBy.length > 0;
                let dateRef = this.getCurrentRef('date');
                datesExist = dateRef.getValue() && dateRef.getValue().length > 0;
            }
            this.existGroupBy = datesExist && groupExist;
        },
        changeOnlyActive(data) {
            this.onlyActive = data;
            this.filterOnlyActive();
            this.changeFilterParameter();
        },
        filterOnlyActive() {
            let self = this;

            if (self.$refs['formItemsDynamicRef']) {
                self.$refs['formItemsDynamicRef'].forEach(function (value) {
                    let currentItems = self.dataItems[value.id] || [];
                    if (self.onlyActive) {
                        // Filter items
                        value.itemsData = currentItems.filter((el) => el.active === undefined || el.active === true);

                        // Filter selected items
                        let itemValues = value.getValue();
                        let filteredValue =
                            itemValues && value.itemsData
                                ? value.itemsData.filter((value) => itemValues.indexOf(value.id) !== -1).map((value) => value.id)
                                : null;

                        // Set selected items
                        value.setModelAndValue(filteredValue);
                    } else {
                        value.itemsData = currentItems;
                    }
                });
            }
        },
        changeFilter(data) {
            this.itemsFilterSelected = this.itemsFilter.filter((value) => data.indexOf(value.id) !== -1);
            this.existFilter = data && data.length > 0;
            this.cleanDynamicItems();
            this.filterOnlyActive();
            this.changeFilterParameter();
        },
        changeFilterDefault() {
            this.changeFilterParameter();
        },
        getItems(id) {
            return this.dataItems[id];
        },
        setItems(data, id) {
            this.$emit('setMainItems', data, id);
            this.checkDynamicFilters();
        },
        checkDynamicFilters() {
            let self = this;
            let allDataLoaded = true;
            self.itemsFilterSelected.forEach(function (item) {
                if (!self.dataItems[item.id]) {
                    allDataLoaded = false;
                }
            });

            this.filterOnlyActive();
            this.$emit('setDisabledDynamicFilter', !allDataLoaded);
        },
        getCurrentRef(key) {
            let currentRef = null;
            let currentItem = this.formItems.find(function (currentValue) {
                return key === currentValue.id;
            });
            if (currentItem.type === 'static') {
                let keyString = key + 'Ref';
                currentRef = this.$refs[keyString] ? this.$refs[keyString] : null;
            } else {
                let keyString = 'formItemsDynamicRef';
                currentRef =
                    this.$refs[keyString] && this.$refs[keyString].length > 0 ? this.getDynamicRef(this.$refs[keyString], key) : null;
            }

            return currentRef;
        },
        getDynamicRef(refs, key) {
            let currentRef = refs.find(function (currentValue) {
                return key === currentValue.id;
            });
            return currentRef ? currentRef : null;
        },
        cleanDynamicItems() {
            let self = this;
            self.formItems.forEach(function (value) {
                if (value.type === 'dynamic') {
                    let currentRef = self.getCurrentRef(value.id);
                    let existFilter = self.itemsFilterSelected.filter((valueSelect) => valueSelect.id === value.id).length > 0;
                    if (currentRef && !existFilter) {
                        currentRef.clear();
                        self.externalParams && self.externalParams[value.id] && (self.externalParams[value.id] = null);
                    }
                }
            });
        },
        getDynamicId(id) {
            return this.idTab + '_' + id;
        },
        toggleCollapse(type) {
            this.collapse[type] = !this.collapse[type];
        },
        getCollapseStatus(type) {
            return this.collapse[type];
        },
        changeFilterParameter() {
            this.$emit('changeFilterParameter');
        },
    },
};
</script>
